/* Inhoudsopgave van een blogartikel ("In dit artikel").

   De artikeltekst komt uit de rich-text-editor, dus de koppen staan niet in de
   Liquid van het thema. Het script leest ze uit de gerenderde tekst, geeft ze
   een id en bouwt de lijst. Zijn er geen koppen, dan blijft de kaart verborgen —
   liever niets dan een lege kaart. Zonder JavaScript staat er ook niets, en dat
   is prima: de inhoudsopgave is een hulpmiddel, geen inhoud. */
(function () {
  'use strict';
  /* Secties nemen dit bestand elk zelf op, dus staat het soms twee of drie keer
     op één pagina. De browser voert elke tag dan opnieuw uit, waardoor listeners
     op document dubbel hangen en één klik twee acties uitvoert. Deze poort laat
     alleen de eerste uitvoering door. */
  window.__hwsLoaded = window.__hwsLoaded || {};
  if (window.__hwsLoaded['component_article_toc']) return;
  window.__hwsLoaded['component_article_toc'] = true;


  function slug(text, index) {
    var base = text
      .toLowerCase()
      .replace(/[^a-z0-9à-ſ\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 60);
    return base ? 'sectie-' + base : 'sectie-' + (index + 1);
  }

  function build(nav) {
    var content = document.querySelector('[data-page-content]');
    var list = nav.querySelector('[data-article-toc-links]');
    if (!content || !list) return;

    var selector = (nav.getAttribute('data-levels') || 'h2')
      .split(',')
      .map(function (level) {
        return level.trim();
      })
      .filter(Boolean)
      .join(',');
    if (!selector) return;

    var headings = [].slice.call(content.querySelectorAll(selector)).filter(function (h) {
      return h.textContent.trim().length > 1;
    });
    if (headings.length < 2) return;

    var links = [];
    headings.forEach(function (heading, index) {
      if (!heading.id) heading.id = slug(heading.textContent.trim(), index);
      var link = document.createElement('a');
      link.className =
        'article-aside__link' +
        (heading.tagName.toLowerCase() === 'h3' ? ' article-aside__link--sub' : '');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      list.appendChild(link);
      links.push({ link: link, heading: heading });
    });

    nav.hidden = false;

    /* Vloeiend scrollen alleen hier, niet document-breed: dat maakte gewoon
       scrollen traag. Geen eigen pixelrekenwerk: scrollIntoView respecteert
       scroll-padding-top van het document (dat de headerhoogte al meeneemt) en
       blijft ook kloppen als er tijdens het scrollen nog afbeeldingen inladen. */
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    list.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link) return;
      var target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', link.getAttribute('href'));
    });

    /* Markeer de kop die in beeld is. */
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function (item) {
            item.link.classList.toggle('is-active', item.heading === entry.target);
          });
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    headings.forEach(function (heading) {
      observer.observe(heading);
    });
  }

  function init() {
    document.querySelectorAll('[data-article-toc]').forEach(build);
    /* main-page gebruikt andere hooks voor dezelfde inhoudsopgave. Het script
       dat die vulde stond in component-facets.js, dat op paginatemplates niet
       laadt; de kolom bleef daar dus leeg. */
    document.querySelectorAll('[data-page-nav]').forEach(function (wrap) {
      var list = wrap.querySelector('[data-page-nav-list]');
      if (!list) return;
      list.setAttribute('data-article-toc-links', '');
      wrap.setAttribute('data-levels', wrap.getAttribute('data-levels') || 'h2');
      wrap.hidden = true;
      build(wrap);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
